<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-1">Acknowledgements</h1>
<p class="para">I would like to thank the excellent staff of the Blount Library over the last several years for their help with this project. Peggy Adkins and Jim Verdini have gone above and beyond the call of duty in helping me secure references. My appreciation goes to the students in my ‘Discovering Exodus’ classes in 2016 and 2018 who helped me think through many of the issues in the book of Exodus. I am grateful to the School of Theology at the University of the South, which invited me to be a Fellow-in-Residence in 2018, and to Romulus Stefanut, Director of the School of Theology Library, who provided me with an office, secured resources for me and extended his friendship. I would like to thank James Hoffmeier, Gordon Johnston, Paul Lawrence and Gary Rendsburg, all of whom discussed various aspects of the project with me. I appreciate their collegial support, while acknowledging that any deficiencies in the work are my responsibility. I am grateful to my wife, Cathy, and to our children, Hannah, Sarah, Mary and Adam, for their love and support. Finally, I would like to thank Philip Law and SPCK, as well as Andrew Knapp and Eerdmans, for the opportunity to write this volume. My prayer is that it might be a blessing to many. <em>Soli Deo gloria!</em></p>
<p class="para1">Ralph K. Hawkins</p>
<p class="para">Feast day of St Ambrose of Milan</p>
<p class="para">Danville, Virginia</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_Acknowledgements.vue?2655c6f6